import "../../../App.css";
import { useState } from "react";
import {
  Button,
  Descriptions,
  Form,
  Layout,
  message,
  Radio,
  Typography,
  InputNumber
} from "antd";
import "antd/dist/reset.css";
import { useOrderId } from "../../../hooks/UseOrderId";
import { Copyable } from "../../common/Copyable";
import WrappedCard from "../../antd/WrappedCard";
import { PaymentType } from "../../../App";
import { usePostCheckoutApi } from "../../../api";
import { ProviderTypeEnum } from "../../../types/ProviderTypeEnum";

const { Content } = Layout;

const copyIconRule = {
  icon: <Copyable />,
  tooltips: ["কপি", "অনুলিপি করা"]
};

function BdBankCardMode({ getCheckoutInfoData }: PaymentType) {
  const id = useOrderId();

  const [submitCheckout, setSubmitCheckout] = useState(false);

  // NOTICE: ant design
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();

  // API
  const { loading, executePost } = usePostCheckoutApi(id);
  const onFormFinish = (values: any) => {
    executePost({
      data: {
        id: id,
        providerType: values.providerType,
        customerAccount: values.customerAccount
      }
    })
      .then(() => {
        setSubmitCheckout(true);
      })
      .catch((error) => {
        messageApi.error("Failed:" + error?.response?.data?.title);
      });
  };

  const validateInput = (_: any, value: number) => {
    const str = String(value);
    const pattern_10 = /^1{1}[^0|1|2]/;
    const pattern_11 = /^01{1}[^0|1|2]/;

    if (!value) {
      return Promise.reject(new Error("একটি বৈধ ওয়ালেট নম্বর লিখুন"));
    }

    if (str.length < 10 || str.length > 11) {
      return Promise.reject(
        new Error("একটি বৈধ ওয়ালেট নম্বর লিখুন৷")
      );
    }

    if (str.length === 10) {
      if (!pattern_10.test(str)) {
        return Promise.reject(new Error("একটি বৈধ ওয়ালেট নম্বর লিখুন"));
      } else {
        return Promise.resolve();
      }
    }

    if (str.length === 11) {
      if (!pattern_11.test(str)) {
        return Promise.reject(new Error("একটি বৈধ ওয়ালেট নম্বর লিখুন"));
      } else {
        return Promise.resolve();
      }
    }
  };

  return (
    <>
      {contextHolder}
      <Content>
        {!submitCheckout &&
          getCheckoutInfoData?.checkoutStatus !== "SUBMITTED" ? (
          <WrappedCard cardTitle="ধাপ 1. অনুগ্রহ করে আপনার পেমেন্ট তথ্য ইনপুট করুন">
            <Form
              form={form}
              onFinish={onFormFinish}
              initialValues={{
                providerType: ProviderTypeEnum.WALLET
              }}
            >
              <Form.Item
                label="অর্থপ্রদানের ধরন নির্বাচন করুন："
                name="providerType"
              >
                <Radio.Group defaultValue={ProviderTypeEnum.WALLET}>
                  <Radio.Button value={ProviderTypeEnum.WALLET}>
                    Nagad
                  </Radio.Button>
                </Radio.Group>
              </Form.Item>

              <Form.Item
                label="অনুগ্রহ করে আপনার নগদ নম্বর ইনপুট করুন："
                name="customerAccount"
                rules={[
                  {
                    validator: validateInput
                  }
                ]}
              >
                <InputNumber
                  type="number"
                  controls={false}
                  style={{ width: "200px" }}
                />
              </Form.Item>

              <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading}>
                  জমা দিন
                </Button>
              </Form.Item>
            </Form>
          </WrappedCard>
        ) : (
          <>
            <WrappedCard cardTitle="তথ্য">
              <Descriptions title="পরিমাণ" bordered>
                <Descriptions.Item label="প্রদেয় পরিমাণ">
                  <Typography.Title
                    copyable={{ ...copyIconRule }}
                    level={5}
                    style={{ margin: 0 }}
                  >
                    {getCheckoutInfoData?.orderAmount}
                  </Typography.Title>
                </Descriptions.Item>
              </Descriptions>
            </WrappedCard>

            <WrappedCard>
              <Descriptions
                title={<div><p>অনুগ্রহ করে নিশ্চিত করুন যে আপনার রিচার্জের পরিমাণ প্রদেয় পরিমাণের সমান।<br />
                  যদি সেগুলি একই না হয় তবে আপনার রিচার্জটি ভুলভাবে আপনার পরিবর্তে অন্য কাউকে রিচার্জ করা হবে।<br />
                  তারা একই কিনা চেক করতে ভুলবেন না দয়া করে.</p>
                  <p>ধাপ 2. ওয়ালেটের বিবরণ কপি করুন এবং অ্যাকাউন্টে অর্থ স্থানান্তর করুন</p></div>}
                bordered
              >
                <Descriptions.Item label="অ্যাকাউন্ট নম্বর">
                  <Typography.Title
                    copyable={{ ...copyIconRule }}
                    level={5}
                    style={{ margin: 0 }}
                  >
                    {getCheckoutInfoData?.receiverAccount}
                  </Typography.Title>
                </Descriptions.Item>

                <Descriptions.Item label="ওয়ালেটের নাম">
                  <Typography.Title level={5} style={{ margin: 0 }}>
                    {getCheckoutInfoData?.receiverBank}
                    <a
                      href="https://play.google.com/store/apps/details?id=com.konasl.nagad&hl=en_SG&gl=US"
                      target="_blank"
                      rel="noreferrer"
                      style={{ marginLeft: "8px" }}
                    >
                      ক্লিক
                    </a>
                  </Typography.Title>
                </Descriptions.Item>
              </Descriptions>
            </WrappedCard>
          </>
        )}
      </Content>
    </>
  );
}

export default BdBankCardMode;
